<template>
  <div class="xrTagAdd">
    <el-tag v-for="(tag, index) in list" :key="index" closable type="info" @close="handleClose(index, tag)">{{tag}}</el-tag>
    <i class="el-icon-circle-plus-outline xrTagAdd-icon" @click="addTag"></i>
  </div>
</template>

<script>
export default {
  name: 'XrTagAdd',
  props: ['value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    value(newValue) {
      this.list = this.CommonUtils.strToArray(newValue);
    },
    list(arr){
      let newValue = this.CommonUtils.createListCheckboxValue(arr);
      this.$emit('change', newValue);
    }
  },
  methods: {
    //添加标签
    addTag(){
      this.$prompt('请输入内容', '添加', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.list.push(value);
      }).catch(() => {});
    },
    handleClose(index, tag){
      this.list.splice(index, 1)
    }
  }
}
</script>
<style scoped>
  .xrTagAdd-icon{font-size: 17px;color: #409eff;cursor: pointer;}
  .xrTagAdd .el-tag.el-tag--info{margin-right: 5px;}
</style>




// WEBPACK FOOTER //
// src/components/XrTagAdd/index.vue